export const sortActiveOrdersNoCarrying = (
	activeOrders,
	continuousOrderDisplayTime,
	separateSortCarrying,
) => {
	try {
		activeOrders.sort((a, b) => {
			if (a.preparationStatus === 'not-ready' && b.preparationStatus === 'is-ready') return -1;
			if (a.preparationStatus === 'is-ready' && b.preparationStatus === 'not-ready') return 1;
			if (a.preparationStatus === 'not-ready' && b.preparationStatus === 'not-ready') {
				if (!a.deliveryId && b.deliveryId) return -1;
				if (a.deliveryId && !b.deliveryId) return 1;

				if (a.readyAt < b.readyAt) return -1;
				if (a.readyAt > b.readyAt) return 1;
				return 0;
			}

			// is-ready: (pending block)

			if (!a.deliveryId && b.deliveryId) return -1;
			if (a.deliveryId && !b.deliveryId) return 1;

			if (!a.deliveryId && !b.deliveryId) {
				// if (a.readyAt > b.readyAt) return -1;
				// if (a.readyAt < b.readyAt) return 1;
				if (a.readyAt < b.readyAt) return -1;
				if (a.readyAt > b.readyAt) return 1;
				return 0;
			}

			// kai oi 2 exoun deliveryId:

			let fieldToCheck = continuousOrderDisplayTime ? 'timeSinceReady' : 'timeSinceAssigned';

			if (separateSortCarrying) {
				if (!a.carrying && b.carrying) return -1;
				if (a.carrying && !b.carrying) return 1;

				if (a[fieldToCheck] > b[fieldToCheck]) return -1;
				if (a[fieldToCheck] < b[fieldToCheck]) return 1;
				return 0;
			}

			if (a[fieldToCheck] > b[fieldToCheck]) return -1;
			if (a[fieldToCheck] < b[fieldToCheck]) return 1;

			return 0;
			// if (continuousOrderDisplayTime) {
			//   if (a.timeSinceReady > b.timeSinceReady) return -1;
			//   if (a.timeSinceReady < b.timeSinceReady) return 1;
			//   return 0;
			// }

			// if (a.assignedAt > b.assignedAt) return -1;
			// if (a.assignedAt < b.assignedAt) return 1;

			// const aHasAssigned = !!a.deliveryId;
			// const bHasAssigned = !!b.deliveryId;

			// if (!aHasAssigned && bHasAssigned) return -1;
			// if (aHasAssigned && !bHasAssigned) return 1;

			// if (a.willBeReadyIn < b.willBeReadyIn) return -1;
			// if (a.willBeReadyIn > b.willBeReadyIn) return 1;
		});

		// activeOrders.sort((a, b) => {
		//   // d
		//   // pe
		//   // pi
		//   if (a.status === b.status) {
		//     return 0;
		//   } else if (a.status === "d" && b.status === "pi") {
		//     return -1;
		//   } else if (a.status === "d" && b.status === "pe") {
		//     return -1;
		//   } else if (a.status === "pe" && b.status === "d") {
		//     return 1;
		//   } else if (a.status === "pi" && b.status === "d") {
		//     return 1;
		//   } else if (a.status === "pe" && b.status === "pi") {
		//     return -1;
		//   } else if (a.status === "pi" && b.status === "pe") {
		//     return 1;
		//   }
		//   return 0;
		// });

		// // if (activeOrders && activeOrders?.length > 0) {
		// idx = activeOrders.findIndex((o) => o.status === "pe");

		// // if (idx === 1) {
		// //   console.log(activeOrders[0], activeOrders[1]);
		// //   // prepei mallon na mpainoun targeted ta items sto sosto simeio tis listas
		// //   // i na kano geniko sort giati
		// //   // auto vasizetai sto return tis postgres pou ta kanei sort 1st lvl me status
		// // }
		// if (idx === -1) {
		//   idx = activeOrders.findIndex((o) => o.status === "pi");

		//   if (idx === -1) {
		//     idx = activeOrders.length;
		//   }
		// }

		// const delayedOrders = activeOrders.slice(0, idx);
		// delayedOrders.sort((a, b) => {
		//   const aHasAssigned = !!a.deliveryId;
		//   const bHasAssigned = !!b.deliveryId;

		//   if (!aHasAssigned && bHasAssigned) return -1;
		//   if (aHasAssigned && !bHasAssigned) return 1;

		//   if (a.willBeReadyIn < b.willBeReadyIn) return -1;
		//   if (a.willBeReadyIn > b.willBeReadyIn) return 1;

		//   return 0;
		//   // if (a.willBeReadyIn < b.willBeReadyIn) {
		//   //   return -1;
		//   // } else if (a.willBeReadyIn > b.willBeReadyIn) {
		//   //   return 1;
		//   // }
		//   // return 0;
		// });
		// lastIdx = idx;

		// idx = activeOrders.findIndex((o) => o.status === "pi");
		// if (idx === -1) {
		//   idx = activeOrders.length;
		// }
		// const pendingOrders = activeOrders.slice(lastIdx, idx);

		// pendingOrders.sort((a, b) => {
		//   if (a.readyAt < b.readyAt) {
		//     return -1;
		//   } else if (a.readyAt > b.readyAt) {
		//     return 1;
		//   }
		//   return 0;
		// });
		// lastIdx = idx;

		// let fieldToCheck = continuousOrderDisplayTime ? "readyAt" : "assignedAt";

		// const pickedOrders = activeOrders.slice(lastIdx, activeOrders.length);
		// pickedOrders.sort((a, b) => {
		//   if (a[fieldToCheck] < b[fieldToCheck]) {
		//     return -1;
		//   } else if (a[fieldToCheck] > b[fieldToCheck]) {
		//     return 1;
		//   }
		//   return 0;
		// });

		// if (activeOrders?.length !== [...delayedOrders, ...pendingOrders, ...pickedOrders].length) {
		//   console.log(
		//     "ERROR LENGTHS NOT SAME -> ",
		//     activeOrders?.length,
		//     " !== ",
		//     [...delayedOrders, ...pendingOrders, ...pickedOrders]?.length
		//   );
		//   console.log(delayedOrders, pendingOrders, pickedOrders);
		// }

		// return [...delayedOrders, ...pendingOrders, ...pickedOrders];
		return activeOrders;
	} catch (error) {
		console.log('sortActiveOrders err:', error);
	}
};

// export const sortActiveOrdersSeparateCarrying = (activeOrders, continuousOrderDisplayTime) => {
//   console.log("sortActiveOrdersSeparateCarrying");
//   let idx;
//   let lastIdx = 0;
//   try {
//     const delayedOrders = [];
//     const pendingOrders = [];
//     const pickedOrders = [];
//     const carriedOrders = [];
//     for (let i = 0; i < activeOrders.length; i++) {
//       if (activeOrders[i].status === "d") {
//         delayedOrders.push(activeOrders[i]);
//       } else if (activeOrders[i].status === "pe") {
//         pendingOrders.push(activeOrders[i]);
//       } else if (activeOrders[i].status === "pi") {
//         if (activeOrders[i].carrying) {
//           carriedOrders.push(activeOrders[i]);
//         } else {
//           pickedOrders.push(activeOrders[i]);
//         }
//       }
//     }

//     delayedOrders.sort((a, b) => {
//       const aHasAssigned = !!a.deliveryId;
//       const bHasAssigned = !!b.deliveryId;

//       if (!aHasAssigned && bHasAssigned) return -1;
//       if (aHasAssigned && !bHasAssigned) return 1;

//       if (a.willBeReadyIn < b.willBeReadyIn) return -1;
//       if (a.willBeReadyIn > b.willBeReadyIn) return 1;

//       return 0;
//     });

//     pendingOrders.sort((a, b) => {
//       if (a.readyAt < b.readyAt) {
//         return -1;
//       } else if (a.readyAt > b.readyAt) {
//         return 1;
//       }
//       return 0;
//     });

//     let fieldToCheck = continuousOrderDisplayTime ? "readyAt" : "assignedAt";

//     pickedOrders.sort((a, b) => {
//       if (a[continuousOrderDisplayTime] < b[continuousOrderDisplayTime]) {
//         return -1;
//       } else if (a[continuousOrderDisplayTime] > b[continuousOrderDisplayTime]) {
//         return 1;
//       }
//       return 0;
//     });

//     carriedOrders.sort((a, b) => {
//       if (a[continuousOrderDisplayTime] < b[continuousOrderDisplayTime]) {
//         return -1;
//       } else if (a[continuousOrderDisplayTime] > b[continuousOrderDisplayTime]) {
//         return 1;
//       }
//       return 0;
//     });
//     return [...delayedOrders, ...pendingOrders, ...pickedOrders, ...carriedOrders];

//     if (activeOrders?.length !== [...delayedOrders, ...pendingOrders, ...pickedOrders].length) {
//       console.log(
//         "ERROR LENGTHS NOT SAME -> ",
//         activeOrders?.length,
//         " !== ",
//         [...delayedOrders, ...pendingOrders, ...pickedOrders]?.length
//       );
//       console.log(delayedOrders, pendingOrders, pickedOrders);
//     }
//   } catch (error) {
//     console.log("sortActiveOrders err:", error);
//   }
// };
